<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
	import {
		taxDifference,querycomapny,taxcomapny,	
	} from "../../../../../api/riskManagement.js"
	import config from "../../../../../../configHttp.js"
export default {
  name: "",
  components: {},
  data: function () {
    return {
		headDatachoose:getdata().headDatachoose,
      headData: getdata().headData,
	  tableDatachoose:[],
      pagination: getdata().pagination,
      tableData: [],
      tablekey: 0,
	  suosq:this.$getdefultMonth(),
	  choosediag:false,
	  companidList:[],
    };
  },
  created() {},
  mounted() {
	  this.uplist()
	  
  },
  methods: {
	  nextdc(){
		  let params = {
				downUrl:config.baseURL+'/report/exprot/taxdifference',
				typeObj:{
					toForm:false,
					fileName:"增值税执行差异",
					fileType:'xlsx',
				},
				params:{
					suosq:this.suosq
				}
		  }
		  this.$downloadcommon(params)
	  },
	  truegs(){
		this.setlist()
	  },
	  nextcompan(){
		  let oulist = this.$refs.tableboxs.getSelectionval()
		  let params = {
		  	suosq:this.suosq,
		  	companyInfo:oulist
		  }
		  taxcomapny(params).then(res=>{
		  	 if(res.data.code==1){
				 this.$message.success('选择成功')
		  		this.choosediag = false
				this.uplist()
		  	}else{
		  		this.$message.error(res.data.msg)
		  	}
		  })
	  },
	  suosqchange(){
		this.pagination.pageNum = 1
		this.pagination.paginationkey++
		this.uplist()
	  },
	  setlist(){
		querycomapny().then(res=>{
			 if(res.data.code==1){
				this.tableDatachoose = res.data.data
				this.choosediag = true
				let list = []
				this.tableDatachoose.map(item=>{
					this.companidList.map(item1=>{
						if(item.companyNo==item1){
							list.push(item)
						}
					})
				})
				this.$nextTick(()=>{
					this.$refs.tableboxs.toggleSelection(list)
				})
			}else{
				this.$message.error(res.data.msg)
			}
		})
	  },
	  sx(){
		  this.uplist()
	  },
	  uplist(){
		  let params={
			  suosq:this.suosq,
			  size:this.pagination.pageSize,
			  current:this.pagination.pageNum
		  }
		taxDifference(params).then(res=>{
			 if(res.data.code==1){
				 this.pagination.total = res.data.data.total
				 this.tableData = []
					res.data.data.records.map(item=>{
						this.companidList.push(item.companyNo)
						this.tableData.push({
							stx:'正差',
							jsgs:'表示增值税实际开票额大于里程碑标准开票额；',
							companyCode:item.companyCode,
							companyName:item.companyName,
							companyNo:item.companyNo,
							createBy:item.createBy,
							createTime:item.createTime,
							delFlag:item.delFlag,
							id:item.id,
							shenbq:item.shenbq,
							updateBy:item.updateBy,
							updateTime:item.updateTime,
							zengzssjBzbq:item.zengzssjBzbq,
							zengzssjBzlj:item.zengzssjBzlj,
							zengzssjSjbq:item.zengzssjSjbq,
							zengzssjSjlj:item.zengzssjSjlj,
							zhengcbq: item.zhengcbq,
							zhengclj: item.zhengclj,
						})
						this.tableData.push({
							stx:'负差',
							jsgs:'表示增值税实际开票额小于里程碑标准开票额；',
							companyCode:item.companyCode,
							companyName:item.companyName,
							companyNo:item.companyNo,
							createBy:item.createBy,
							createTime:item.createTime,
							delFlag:item.delFlag,
							id:item.id,
							shenbq:item.shenbq,
							updateBy:item.updateBy,
							updateTime:item.updateTime,
							zengzssjBzbq:item.zengzssjFcbzbq,
							zengzssjBzlj:item.zengzssjFcbzlj,
							zengzssjSjbq:item.zengzssjFcsjbq,
							zengzssjSjlj:item.zengzssjFcsjlj,
							fucbq: item.fucbq,
							fuclj: item.fuclj,
						})
					})
			}else{
				this.tableData = []
				this.$message.error(res.data.msg)
			}
		})  
	  },
    sizechange(e) {
      this.pagination.pageSize = e;
	  this.uplist()
    },
    currentChange(e) {
      this.pagination.pageNum = e;
	  this.uplist()
    },
	spanmethod({
		row,
		column,
		rowIndex,
		columnIndex
	}) {
		if (columnIndex  === 0) {
			if (rowIndex % 2 === 0) {
				return {
					rowspan: 2,
					colspan: 1
				};
			} else {
				return {
					rowspan: 0,
					colspan: 0
				};
			}
		}
	},
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
